import { Component } from '@angular/core';
import { FuseTranslationLoaderService } from '../../../@fuse/services/translation-loader.service';
import { locale as polish } from '../../translations/pl';
import { locale as english } from '../../translations/en';

@Component({
  selector: 'app-fractions-container',
  templateUrl: './fractions-container.component.html',
  styleUrls: ['./fractions-container.component.scss']
})
export class FractionsContainerComponent {

  constructor(private _fuseTranslationLoaderService: FuseTranslationLoaderService) {
    this._fuseTranslationLoaderService.loadTranslations(polish, english);
  }

}
